<template>
  <selects-wrappers-responsive-select
    :selectedOption="activeOption.value"
    :title="getContent(gamesContent?.currentLocaleData, gamesContent?.defaultLocaleData, 'sortLabel')"
    :label="getContent(gamesContent?.currentLocaleData, gamesContent?.defaultLocaleData, 'sortLabel')"
    :options="sortOptions"
    identifierKey="value"
    bottomSheetMaxWidth="48px"
    hideActionBtn
    @update:selectedOption="onSelectOption"
  >
    <template #bottom-sheet-activator="{ onOpen }">
      <div class="games-sorting-mobile" @click="onOpen">
        <atomic-icon id="arrow-sort" />
      </div>
    </template>
  </selects-wrappers-responsive-select>
</template>

<script setup lang="ts">
  import type { ISortOption } from '@skeleton/core/types';

  const props = withDefaults(
    defineProps<{
      sortBy?: string;
      sortOrder?: string;
      sortOptions: ISortOption[];
      heightBottomSheet?: string;
    }>(),
    {
      heightBottomSheet: '40',
    }
  );

  const { getContent } = useProjectMethods();
  const { content: gamesContent } = useGamesContent();

  const { selectedOption } = await useSortingOptions();

  const route = useRoute();
  const router = useRouter();

  const activeOption = ref<Record<string, any>>({});

  const updateQueryWithReplace = () => {
    router.replace({
      query: {
        ...route.query,
        sortBy: activeOption.value.sortBy,
        sortOrder: activeOption.value.sortOrder,
      },
    });
  };

  const parseSort = () => {
    activeOption.value = selectedOption(props.sortBy, props.sortOrder);
  };

  const onSelectOption = (value: string | number) => {
    const matched = props.sortOptions.find(option => option.value === value);
    activeOption.value = matched ?? props.sortOptions[0];

    updateQueryWithReplace();
  };

  watchEffect(() => {
    parseSort();
  });
</script>

<style src="~/assets/styles/components/bottom-sheet/games-sorting-mobile.scss" lang="scss" />
